import { FaHardHat } from "react-icons/fa";

const Loader = () => {
  return (
    <div className="fixed inset-0 bg-[#082B57] flex items-center justify-center z-[99999]">

      <div className="text-center">

        <div className="relative flex justify-center">

          <div className="w-28 h-28 border-4 border-white/20 rounded-full"></div>

          <div className="absolute w-28 h-28 border-4 border-transparent border-t-[#F59E0B] rounded-full animate-spin"></div>

          <div className="absolute inset-0 flex items-center justify-center">
            <FaHardHat className="text-[#F59E0B] text-4xl" />
          </div>

        </div>

        <h3 className="text-white font-bold text-2xl mt-6">
          AZ Construction
        </h3>

        <p className="text-white/70 mt-2">
          Building Dreams Into Reality...
        </p>

      </div>

    </div>
  );
};

export default Loader;